import { useState, useEffect } from "react";
import { supabase, perfilService } from "./services/supabase";
import { LoginScreenEmail, LogoutButton, ProfileGate } from "./components/AuthEmail";
import CampoIA from "./App";
import { C } from "./components/ui";

export default function AppWithAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const [profileChecked, setProfileChecked] = useState(false);

  useEffect(() => {
    // Verificar sesión actual
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user || null);
      setLoading(false);
    });

    // Escuchar cambios de autenticación
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setUser(session?.user || null);
      }
    );

    return () => subscription?.unsubscribe();
  }, []);

  // Cuando hay usuario, verificar si tiene perfil cargado
  useEffect(() => {
    if (!user) {
      setProfile(null);
      setProfileChecked(false);
      return;
    }
    let cancel = false;
    perfilService
      .obtener()
      .then((p) => {
        if (!cancel) {
          setProfile(p);
          setProfileChecked(true);
        }
      })
      .catch(() => {
        if (!cancel) {
          setProfile(null);
          setProfileChecked(true);
        }
      });
    return () => {
      cancel = true;
    };
  }, [user]);

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: C.fondo,
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 10 }}>🌾</div>
          <div>Cargando...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <LoginScreenEmail onLogin={(u) => setUser(u)} />;
  }

  // Esperando a saber si tiene perfil
  if (!profileChecked) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: C.fondo,
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 10 }}>🌾</div>
          <div>Cargando perfil...</div>
        </div>
      </div>
    );
  }

  // Logueado pero SIN perfil → candado: completar datos antes de entrar
  if (!profile) {
    return (
      <ProfileGate
        email={user.email}
        onSave={(p) => setProfile(p || { completado: true })}
      />
    );
  }

  // Renderizar la app con usuario autenticado
  return (
    <CampoIA
      user={user}
      profile={profile}
      onProfileUpdate={(p) => setProfile((prev) => ({ ...prev, ...p }))}
      LogoutButton={() => (
        <LogoutButton user={user} onLogout={() => setUser(null)} />
      )}
    />
  );
}
